__turbopack_context__.v({
  "ActiveButton": "_1ekhW_ActiveButton",
  "Avatar": "_1ekhW_Avatar",
  "AvatarOverflow": "_1ekhW_AvatarOverflow",
  "Avatars": "_1ekhW_Avatars",
  "Card": "_1ekhW_Card",
  "Card--Active": "_1ekhW_Card--Active",
  "Card--Entering": "_1ekhW_Card--Entering",
  "CardCountry": "_1ekhW_CardCountry",
  "CardCountryCode": "_1ekhW_CardCountryCode",
  "CardHeader": "_1ekhW_CardHeader",
  "CardMeta": "_1ekhW_CardMeta",
  "CardName": "_1ekhW_CardName",
  "Dot": "_1ekhW_Dot",
  "EdgeEnter": "_1ekhW_EdgeEnter",
  "EdgeLabel": "_1ekhW_EdgeLabel",
  "Frozen": "_1ekhW_Frozen",
  "Handle": "_1ekhW_Handle",
  "HiddenCount": "_1ekhW_HiddenCount",
  "MetaText": "_1ekhW_MetaText",
  "Root": "_1ekhW_Root",
  "fade-in": "_1ekhW_fade-in",
  "skeleton-loading": "_1ekhW_skeleton-loading",
});
